module.exports = __webpack_public_path__ + "static/desktop/img/custom-intro-en.f3e47879.png";